import React, { useState,useEffect } from 'react';
import DOMPurify from 'dompurify';
import { Box, DialogContent, DialogActions, Button } from '@mui/material';
import BoardDetail from './BoardDetailPopup';
import BoardWrite from './BoardWritePopup';
import axios from 'axios';
import { useApiUtil } from "@/utils/apiUtil";
import { useSelector } from 'react-redux';
import CommonPopup from "@/comp/CommonPopup";

// 공통코드
import { useCommon } from "@/utils/common";

const UpperDeptPopup = ({ open, onClose, board, boardType, boardInfo, boardStatus, setRefreshFlag, blbdCd }) => {

  const commonJs = useCommon();

  if(boardStatus === "new") {
    board = null;
  }

  const [isWriteMode, setIsWriteMode] = useState(false);
  const [boardQuery, setBoardQuery] = useState('insert'); 
  const [boardTitle, setBoardTitle] = useState('');
  const [boardInptId, setBoardInptId] = useState('');
  const [boardInqCnt, setBoardInqCnt] = useState(0);
  const [boardCntn, setBoardCntn] = useState('');
  const [hrankNotiNo, setHrankNotiNo] = useState(board?.HRANK_NOTI_NO || "");
  const [pNotiNo, setPNotiNo] = useState(board?.P_NOTI_NO || "");
  const [answLevl, setAnswLevl] = useState(board?.ANSW_LEVL || 0);
  const [answOrder, setAnswOrder] = useState(board?.ANSW_ORDER || 0);
  
  const [files, setFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [deleteFiles, setDeleteFiles] = useState([]);

  const boardPopTile = boardType + " 게시글";

  const { gfnCallApi } = useApiUtil();
  const userId = useSelector((state) => state.user.userId);

  const handleBoardReply = () => {
    setBoardQuery('append');
    setAnswLevl(board.ANSW_LEVL+1);
    setIsWriteMode(true);
  };

  const handleBoardModify = () => {
    setBoardQuery('update');
    setIsWriteMode(true);
  };

  const handleBoardDelete = () => {
    setBoardQuery('delete');
  }

  const handleBoardClose = () => {
    setIsWriteMode(false);
    setBoardQuery('insert');
    onClose();
  }

  const handleBoardSave = async () => {

    if(!boardQuery === 'delete') {
      if(!boardTitle || boardTitle == "") {
        commonJs.showToastMsg("제목은 필수 입력입니다.");
        return;
      }

      if(!boardCntn || boardCntn == "") {
        commonJs.showToastMsg("내용은 필수 입력입니다.");
        return;
      }      
    }

  //  try {
      let fileId = null;

      // 1. 파일 업로드 (있을 경우만)
      if (files.length > 0) {
        const formData = new FormData();
        formData.append("USER_ID", userId ?? '');
        formData.append("FILE_ID", board?.FILE_ID ?? '');
        formData.append("BOARD_CD", "0001");
        files.forEach((file) => formData.append("file", file));

        const uploadRes = await gfnCallApi({
            method: "post",
            url: "uploadBoardFile",
            data: formData,
            isMultipart: true,
            showMsg: false, 
          });        
        if(!uploadRes || uploadRes.code < 0) {
          commonJs.showToastMsg("파일업로드에 실패 하였습니다.");
          return;
        }  
        /*
        const uploadRes = await axios.post("uploadBoardFile", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        */

        fileId = uploadRes.data.fileId; // 백엔드에서 반환된 fileId
      }

      // 2. 파일 삭제 (있을 경우만)
      if (deleteFiles.length > 0) {

        const deleteRes = await gfnCallApi({
            method: "post",
            url: "deleteBoardFiles",
            data: deleteFiles,
            showMsg: false, 
          });       

        if(!deleteRes || deleteRes.code < 0) {
          commonJs.showToastMsg("파일처리에 실패 하였습니다.");
          return;
        }            
        /*
        const deleteRes = await axios.post("deleteBoardFiles", deleteFiles, {
          headers: { "Content-Type": "application/json" },
        });
        */

        // 삭제된 fileId 목록 추출
        const deletedIds = deleteFiles.map(f => f.fileId);

        // uploadedFiles에서 삭제된 파일 제거
        setUploadedFiles(prev =>
          prev.filter(f => !deletedIds.includes(f.fileId))
        );

        setDeleteFiles([]);

        if(uploadedFiles.length === 0) {
          const fileParam = {
            blbdCd: board.BLBD_CD,
            notiNo: board.NOTI_NO
          };

          const upRes = await gfnCallApi({
              method: "post",
              url: "deleteBoardFileId",
              data: fileParam,
              showMsg: false, 
            });       
          /*            
          await axios.post('/api/deleteBoardFileId', fileParam, {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
          });
          */
        }
      }

      // 3. 게시글 저장
      const payload = {
        NOTI_NO: board?.NOTI_NO,
        TITLE: boardTitle,
        INQ_CNT: boardInqCnt,
        CNTN: DOMPurify.sanitize(boardCntn || ''),
        FILE_ID: fileId, // 여기 포함
        BLBD_CD: board?.BLBD_CD || blbdCd,
        HRANK_NOTI_NO: hrankNotiNo || 0,
        P_NOTI_NO: pNotiNo || 0,
        ANSW_LEVL: answLevl || 0,
        ANSW_ORDER: answOrder || 0,
        boardQuery
      };
    
      const result = await gfnCallApi({
        method: "post",
        url: "vocSave",
        data: payload,
        showMsg: true, // "저장됨" 토스트 자동 표시
      });
      if(!result || result.code < 0) {
        return;
      }    
      setRefreshFlag(true);
      handleBoardClose();
      setFiles([]);
  }

  const getFooterActions = () => {
    let footer = [];
    if(board && !isWriteMode) {
      const replyYn = boardInfo?.REPLY_YN;
      if(replyYn === '1') {
        footer.push({ label: "답글" , "onClick": handleBoardReply });
      }

      if(board.INPT_ID === userId || userId === 'admin') {
        footer.push({ label: "수정" , "onClick": handleBoardModify });
        footer.push({ label: "삭제" , "onClick": handleBoardDelete });
      }
      
    } else {
      footer.push({ label: "저장" , "onClick": handleBoardSave });
    }
    return footer;
  };

  useEffect(() => {
    if(boardQuery === 'delete') {
      handleBoardSave();
    }
  }, [boardQuery]);

  useEffect(() => {
    if(open) {
      if(boardStatus === "new") {

      }
      //searchBoardInfo();
    }
  }, [open, boardStatus]);

  return (

    <CommonPopup
      open={open}
      onClose={handleBoardClose}
      title={board && !isWriteMode?boardPopTile:boardPopTile + " 작성"}
      width={850}
      height={board && !isWriteMode ? 800 : 540}
      footerActions={getFooterActions()}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "5px"
        }}
      >  

          <div>
            <>
            {(board && !isWriteMode) ? 
              <BoardDetail
                board={board}
                boardType={boardType}
                setUploadedFiles={setUploadedFiles}
                boardInfo={boardInfo}
              />
               :
              <BoardWrite
                board={board}
                boardTitle={boardTitle}
                setBoardTitle={setBoardTitle}
                setBoardInptId={setBoardInptId}
                setBoardInqCnt={setBoardInqCnt}
                boardCntn={boardCntn}
                setBoardCntn={setBoardCntn}
                files={files}
                setFiles={setFiles}
                uploadedFiles={uploadedFiles}
                setUploadedFiles={setUploadedFiles}
                setDeleteFiles={setDeleteFiles}
                boardQuery={boardQuery}
                hrankNotiNo={hrankNotiNo}
                setHrankNotiNo={setHrankNotiNo}
                pNotiNo={pNotiNo}
                setPNotiNo={setPNotiNo}                
                answLevl={answLevl}
                setAnswLevl={setAnswLevl}
                answOrder={answOrder}
                setAnswOrder={setAnswOrder}
                boardType={boardType}
                boardInfo={boardInfo}
              />
            }
            </>
        </div>
      {/*}
        {(board && !isWriteMode) ?
          <DialogActions>
            { boardInfo[0]?.ANSW_YN === '1' ? (
              <Button onClick={handleBoardReply}>답글</Button>
            )
            : null }
            { board.INPT_ID === userId || userId === 'admin' ? (
              <div>
                <Button onClick={handleBoardModify}>수정</Button>
                <Button onClick={handleBoardDelete}>삭제</Button>
              </div>
            )
            : null }
            <Button onClick={() => {onClose(); handleBoardClose();}}>닫기</Button>
          </DialogActions>
        : 
          <DialogActions>
            <Button onClick={handleBoardSave}>저장</Button>
            <Button onClick={() => {onClose(); handleBoardClose();}}>닫기</Button>
          </DialogActions>
        }
      {*/}    
      </Box>  
    </CommonPopup>  
  );
};

export default UpperDeptPopup;
